import { apiFetch, apiNoContentTypeFetch } from "./index";
import { getApiBaseUrl } from "./baseUrl";
const API_BASE = getApiBaseUrl();

export const getUserInfos = async (token: string) => {
  return await apiFetch<UserInfo>(`${API_BASE}/api/management/user-info`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateUserInfos = async (token: string, value: any) => {
  return await apiFetch(`${API_BASE}/api/management/user-info`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(value),
  });
};

export const updateUserLanguage = async (token: string, lang: "日本語" | "英語") => {
  return await apiFetch<UserInfo>(`${API_BASE}/api/management/user-info/language`, {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ lang }),
  });
};

export const changeEmail = async (token: string, value: string) => {
  return await apiFetch(`${API_BASE}/api/management/change-email`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({newEmail: value}),
  });
};

export const changePassword = async (token: string, value: string) => {
  return await apiFetch(`${API_BASE}/api/management/change-password`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({newPassword: value}),
  });
};

export const uploadImage = async (token: string, file: File) => {
  const formData = new FormData();
  formData.append("image", file);

  return await apiNoContentTypeFetch(`${API_BASE}/api/management/upload-image`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
};

export const deleteProfileImage = async (token: string) => {
  return await apiFetch<{ profile_image_url: null }>(`${API_BASE}/api/management/profile-image`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteAccount = async (token: string) => {
  return await apiFetch(`${API_BASE}/api/management/delete-account`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getGoogleCalendarStat = async (token: string) => {
  return await apiFetch<GoogleCalendarStatus>(`${API_BASE}/api/management/user-google-calendar`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export interface SubscriptionStatus {
  plan_type: string;
  subscription_expires_at: string | null;
}

export async function syncSubscription(): Promise<SubscriptionStatus> {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 15000);
  try {
    return await apiFetch<SubscriptionStatus>(`${API_BASE}/api/management/subscription/sync`, {
      method: "POST", signal: controller.signal,
    });
  } finally { clearTimeout(timeout); }
}

export interface UserInfo {
  id: number;
  email: string;
  nickname?: string;
  first_name?: string;
  last_name?: string;
  title?: string;
  gender?: number;
  birth_date?: string;
  // 署名付きURL（期限付き）。取得のたびに変わるため、画像のキャッシュには profile_image_key を使う。
  profile_image_url?: string | null;
  profile_image_key?: string | null;
  prefectures?: string;
  phone?: string;
  lang?: string;
  hobby?: string;
  mbti?: string;
  points: number;
  level: number;
  plan_type: string;
  subscription_expires_at: string;
}

export interface GoogleCalendarStatus {
  use_google_calendar: boolean;
}
